var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:edit",
                          value: _vm.permissionPrefix,
                          expression: "permissionPrefix",
                          arg: "edit"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.routePrefix + ".edit",
                          params: { id: _vm.id }
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-edit" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("select-captain-bonus-types", {
                      attrs: {
                        options: {
                          id: "captain_bonus_type",
                          label: "type",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.type,
                        callback: function($$v) {
                          _vm.type = $$v
                        },
                        expression: "type"
                      }
                    }),
                    _c("select-captain-bonus-owner-types", {
                      attrs: {
                        options: {
                          id: "captain_bonus_owner_type",
                          label: "owner_type",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.owner_type,
                        callback: function($$v) {
                          _vm.owner_type = $$v
                        },
                        expression: "owner_type"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "owner_id",
                          step: 1,
                          label: "owner_id",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.owner_id,
                        callback: function($$v) {
                          _vm.owner_id = $$v
                        },
                        expression: "owner_id"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: { id: "name", label: "name", disabled: true }
                      },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = $$v
                        },
                        expression: "name"
                      }
                    }),
                    _c("input-textarea", {
                      attrs: {
                        options: {
                          id: "description",
                          label: "description",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "revenue",
                          label: "revenue",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.revenue,
                        callback: function($$v) {
                          _vm.revenue = $$v
                        },
                        expression: "revenue"
                      }
                    }),
                    _c("input-datetime", {
                      attrs: {
                        options: {
                          id: "from_date",
                          label: "from_date",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.from_date,
                        callback: function($$v) {
                          _vm.from_date = $$v
                        },
                        expression: "from_date"
                      }
                    }),
                    _c("input-datetime", {
                      attrs: {
                        options: {
                          id: "to_date",
                          label: "to_date",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.to_date,
                        callback: function($$v) {
                          _vm.to_date = $$v
                        },
                        expression: "to_date"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "whenDeliveredOrdersReaches",
                          step: 1,
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "when_delivered_orders_reaches",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.whenDeliveredOrdersReaches,
                        callback: function($$v) {
                          _vm.whenDeliveredOrdersReaches = $$v
                        },
                        expression: "whenDeliveredOrdersReaches"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-checkbox", {
                      attrs: {
                        options: {
                          id: "enabled",
                          label: "enabled",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.enabled,
                        callback: function($$v) {
                          _vm.enabled = $$v
                        },
                        expression: "enabled"
                      }
                    }),
                    _c("input-checkbox", {
                      attrs: {
                        options: {
                          id: "expired",
                          label: "expired",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.expired,
                        callback: function($$v) {
                          _vm.expired = $$v
                        },
                        expression: "expired"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }